import React from 'react';
import { Card } from './ui/card';
import { Play, Star, Clock } from 'lucide-react';

const MoviesSection = () => {
  const handleCardClick = () => {
    // Scroll to hero CTA button
    document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const movies = [
    {
      id: 1,
      title: "Ação Explosiva",
      genre: "Ação",
      rating: 4.8,
      duration: "2h 15min",
      image: "https://images.pexels.com/photos/436413/pexels-photo-436413.jpeg"
    },
    {
      id: 2,
      title: "Comédia Romântica",
      genre: "Romance",
      rating: 4.5,
      duration: "1h 45min",
      image: "https://images.pexels.com/photos/33129/popcorn-movie-party-entertainment.jpg"
    },
    {
      id: 3,
      title: "Suspense Psicológico",
      genre: "Thriller",
      rating: 4.9,
      duration: "2h 30min",
      image: "https://images.pexels.com/photos/109669/pexels-photo-109669.jpeg"
    },
    {
      id: 4,
      title: "Ficção Científica",
      genre: "Sci-Fi",
      rating: 4.7,
      duration: "2h 05min",
      image: "https://images.pexels.com/photos/436413/pexels-photo-436413.jpeg"
    },
    {
      id: 5,
      title: "Drama Intenso",
      genre: "Drama",
      rating: 4.6,
      duration: "2h 20min",
      image: "https://images.pexels.com/photos/33129/popcorn-movie-party-entertainment.jpg"
    },
    {
      id: 6,
      title: "Aventura Épica",
      genre: "Aventura",
      rating: 4.8,
      duration: "2h 40min",
      image: "https://images.pexels.com/photos/109669/pexels-photo-109669.jpeg"
    }
  ];

  return (
    <section id="filmes" className="py-16 md:py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Catálogo de <span className="text-red-600">Filmes</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl">
            Assista aos melhores filmes em qualidade HD e 4K
          </p>
        </div>

        {/* Movies Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {movies.map((movie) => (
            <Card
              key={movie.id}
              onClick={handleCardClick}
              className="group relative overflow-hidden bg-zinc-900 border-zinc-800 hover:border-red-600 transition-all duration-300 cursor-pointer"
            >
              {/* Thumbnail */}
              <div className="relative h-64 md:h-80 overflow-hidden">
                <img
                  src={movie.image}
                  alt={movie.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors"></div>

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform">
                    <Play className="w-8 h-8 text-white fill-white" />
                  </div>
                </div>

                {/* Rating Badge */}
                <div className="absolute top-4 right-4 bg-black/80 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm font-bold flex items-center gap-1">
                  <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                  {movie.rating}
                </div>

                {/* Duration */}
                <div className="absolute bottom-4 right-4 bg-black/80 backdrop-blur-sm text-white px-2 py-1 rounded text-xs flex items-center gap-1">
                  <Clock className="w-3 h-3" />
                  {movie.duration}
                </div>
              </div>

              {/* Movie Info */}
              <div className="p-4 md:p-6">
                <span className="text-red-500 text-sm font-semibold uppercase tracking-wide">
                  {movie.genre}
                </span>
                <h3 className="text-xl font-bold text-white mt-2 group-hover:text-red-500 transition-colors">
                  {movie.title}
                </h3>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MoviesSection;
